import { autoinject } from "aurelia-framework";
import { Zone } from '../../models/zone';
@autoinject
export class QuickIndicators {

	zone: Zone;
	constructor() {}

	bind(bindingContext: any) {
    this.zone = bindingContext.zone;

  }
}